import { ICalculationUpdate } from 'modules/accommodations/features/reservations/models';
import API from 'services/api';

export const calculateFromPriceList = ({
  id,
  payload,
}: {
  id: string;
  payload: ICalculationUpdate;
}) => {
  return API.post(`api/accommodation/calculations/${id}/calculateFromPriceList`, payload).then(
    response => response?.data,
  );
};
